import api from '../api';

// Mocks
// import { mockManagerGlobalFilters } from '../../mocks/mock-global-filters';

/**
 * Get manager global filters
 * @param {string} path - The path of the page
 * @returns {Promise<ApiManagerGlobalFilters>} The manager global filters
 */
export const getGlobalFilters = async (path) => {
  const response = await api.get(`/global-filters?path=${path}`);
  return response.data;
  // return mockManagerGlobalFilters;
};

/**
 * Post manager global filters
 * @param {string} path - The path of the page
 * @param {ApiManagerGlobalFiltersCreate} data - The global filters data
 * @returns {Promise<ApiManagerGlobalFiltersCreate>} The created global filters
 */
export const postGlobalFilters = async (path, data) => {
  // // Simulate network delay
  // await new Promise((resolve) => {
  //   setTimeout(resolve, 2000);
  // });

  // Normalize selectedOption: convert empty string to null (API requires string >= 1 char or null)
  const normalizedData = {
    ...data,
    personalViews: data?.personalViews ? {
      ...data.personalViews,
      selectedOption: data.personalViews.selectedOption === '' ? null : data.personalViews.selectedOption,
    } : data.personalViews,
  };

  const response = await api.post(`/global-filters?path=${path}`, normalizedData);
  return response.data;
};
